import React from "react";
import { API } from "./api";

// Kingdom Artwork Library — reusable character cutouts extracted from the official books.
// Reference any asset by slug; the browser caches the (immutable) WebP for a week.
export const KINGART_BASE = `${API}/kingdom-art`;
// Approved emotion faces are replaced in-place at the same slug (feeling-happy, feeling-silly…),
// so returning devices can serve a stale cached image for up to a week. Append a revision token
// to feeling-art URLs for proper cache invalidation — BUMP this whenever the approved Sir
// Gingerman emotion faces are updated so every device (mobile/tablet/desktop) fetches the new art.
export const FEELING_ART_REV = "20261005b";
export const kingArt = (slug) => {
  const url = `${KINGART_BASE}/${slug}/image`;
  return slug && slug.startsWith("feeling-") ? `${url}?rev=${FEELING_ART_REV}` : url;
};
// Emotion illustration matching a feeling (consistent "feeling buddy" set — emotion-first SEL).
export const feelingArt = (feeling) => kingArt(`feeling-${feeling}`);

// Curated launch slugs (friendly aliases so components read nicely).
export const ART = {
  sitting: "sitting-grass",
  soccer: "soccer",
  walking: "walking-backpack",
  celebrate: "celebrate-clown",
  crownBrave: "crown-brave",
  crownReading: "crown-reading",
  happy: "happy-laugh",
  thinking: "thinking",
  holdingBook: "holding-book",
  worried: "reading-worried",
  cozyReading: "reading-blanket",
  detective: "pajamas",
  scientist: "scientist",
  theEnd: "the-end",
  hug: "hug-parent",
  friend: "excited-book",
};

// Drop-in <img> for a Kingdom artwork asset (transparent background).
export function KingArt({ slug, alt = "Sir Gingerman", className = "", style, testId, ...rest }) {
  return (
    <img
      src={kingArt(slug)}
      alt={alt}
      loading="lazy"
      draggable={false}
      data-testid={testId}
      className={className}
      style={style}
      {...rest}
    />
  );
}
